import { render, staticRenderFns } from "./FaqReg.vue?vue&type=template&id=1ad5f2d7&scoped=true"
import script from "./FaqReg.vue?vue&type=script&lang=js"
export * from "./FaqReg.vue?vue&type=script&lang=js"
import style0 from "./FaqReg.vue?vue&type=style&index=0&id=1ad5f2d7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5f2d7",
  null
  
)

export default component.exports